var path = '/templates/projects.segments/campaign_segment_edit_custom.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ../enterprise/src/zenclerk_modules/projects.segments/campaign_segment_edit_custom.html
// module id = 1480
// module chunks = 0